import { render, staticRenderFns } from "./sso-mapping-section.vue?vue&type=template&id=c6e67882&scoped=true"
import script from "./sso-mapping-section.vue?vue&type=script&lang=js"
export * from "./sso-mapping-section.vue?vue&type=script&lang=js"
import style0 from "./sso-mapping-section.vue?vue&type=style&index=0&id=c6e67882&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6e67882",
  null
  
)

export default component.exports